import { Box } from '@chakra-ui/react';
import { Filter } from '../filters';
import { useDispatch, useSelector } from 'react-redux';
import { atsJobsActions, atsJobsApiActions, getAtsJobs } from '@/store/atsJobs';
import { jobsNewFilterConfig } from '@/pages/ats-jobs/utils/jobsHelpers';
import { useEffect, useMemo } from 'react';
import { selectUsers } from '@/store/users/selectors';
import { useApplyFilterHandler } from '@/components/filters_revamp/hooks';

export const CopyFromFilters = ({ setFilters: _setFilters, filters, type }) => {
  const { jobOffices, jobDepartments } = useSelector(getAtsJobs);
  const dispatch = useDispatch();

  const allUsers = useSelector(selectUsers);

  useEffect(() => {
    dispatch(atsJobsApiActions('getAllOffices'));
    dispatch(atsJobsApiActions('getAllDepartments'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    applyFilter,
    clearFilter,
    clearAllFilter,
    applySort,
    applySearch,
    setCurrentView,
  } = atsJobsActions;

  const { handleApplyFilter } = useApplyFilterHandler({
    applyFilter,
    customFilters: [],
    asyncFields: [],
  });

  const filterActions = (filterData) => {
    const filterActions = {
      apply: ({ values }) => {
        handleApplyFilter(values);
      },
      clear: ({ key }) => dispatch(clearFilter({ key })),
      clearAll: () => dispatch(clearAllFilter()),
      sort: ({ option }) => dispatch(applySort(option)),
      search: ({ searchTerm }) => {
        if (searchTerm) {
          dispatch(applySearch({ searchTerm }));
        } else {
          dispatch(applySearch({ searchTerm: '' }));
        }
      },
      view: ({ view }) => dispatch(setCurrentView({ view })),
      default: () => console.log('Unhandled filter action'),
    };

    const action = filterActions[filterData.type] || filterActions.default;
    action(filterData);
  };

  const filterConfig = useMemo(() => {
    const config = jobsNewFilterConfig(jobOffices, jobDepartments, allUsers);
    if (type === 'jobStage') {
      const { job_statuses: _removed, ...rest } = config;
      return rest;
    }
    return config;
  }, [jobOffices, jobDepartments, allUsers, type]);

  return (
    <Box p=".5em 0">
      <Filter
        filterConfig={filterConfig}
        isSearchEnabled
        activeFilters={filters}
        filterActions={filterActions}
        hideSearchFullView={false}
        searchTerm={filters?.name}
        isNewFilter={true}
        selected={filters?.feConfig}
        accordionTitle="Job filters"
      />
    </Box>
  );
};
